var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-image"},[_c('div',{staticClass:"main-pic"},[_c('img',{staticClass:"img-store",attrs:{"src":'/static/pictures/mock/main-image-static.jpg',"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }